<template>

	<!-- content -->
	<div id="content" class="content mypage">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">마이페이지</h2>
			</div>
			<div class="mypage-profile" v-if="coAccountVO != null">
				<div class="name">
					<strong>{{ coAccountVO.nickName }} 님</strong>
					<p>{{ coAccountVO.coEmailId }}</p>
				</div>
				<div class="btn-wrap">
					<router-link to="/mypage/infoForm"  class="btn btn-sm btn-primary" >회원정보 수정</router-link>
					<a href="/mypage/changePassword" class="btn btn-sm btn-primary" v-if="!coAccountVO.isSnsLogin">비밀번호 변경</a>
				</div>

			</div>
			<div class="mypage-menu">
				<ul class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
					<li class="col ico-my2"><router-link to="/app/education/mine/">학습 현황</router-link></li>
					<li class="col ico-my9"><router-link to="/app/education/mine/wish/">관심 교육</router-link></li>
					<li class="col ico-my4"><router-link :to="'/app/board/site_qna?writerKey=' + getLoginId()">나의 문의</router-link></li>
					<li class="col ico-my5"><router-link to="/app/board/site_notice">공지사항</router-link></li>
					
					<template v-if="isShowShopping">
						<li class="col ico-my10"><router-link to="/app/shop/cartList">장바구니</router-link></li>
						<li class="col ico-my6"><router-link to="/mypage/paymentState">나의 구매 목록</router-link></li>
						<li class="col ico-my7"><a href="javascript:;" @click="plzWait" >Autodesk 구매 현황</a></li>
						<li class="col ico-my8"><a href="javascript:;" @click="plzWait">Box 제품 구매 현황</a></li>
						<li class="col ico-my8"><router-link to="/box-series/offlineCertificationHistory">오프라인 인증 신청 내역</router-link></li>
					</template>
				</ul>
			</div>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "index",
	data() {

		return {

			coInfoVO: null,
			coAccountVO: null,

			isShowShopping: true,
			isShowSnsLogin: true,
		}
	},
	async created() {

		await !this.requireLogin(this, false)
		this.init();

	},
	mounted() {

	},
	methods: {

		init() {

			this.coAccountVO = this.getSessionProc();
			console.log(this.coAccountVO)
			this.getCompanyInfo();
		},


		async getCompanyInfo () {

			const self = this

			self.coInfoVO = await self.getCoInfoVO()
			// 아이폰이 경우 사이트 설정 따라가게 설정
			if ( self.appDevice() === "IOS" ) {
				self.isShowShopping = self.coInfoVO.isIosShop
				self.isShowSnsLogin = self.coInfoVO.isIosSns
			}

		},


		plzWait () {

			// this.swalUtils.gritter("준비중", "정보조회를 위해 현재 준비중입니다.<br>잠시만 기다려주세요.", "info", 3000)
			this.swalUtils.gritter("준비중", "해당기능은 준비중입니다.<br>빨리 제공할 수 있게 준비중입니다.", "info", 3000)

		},

	}
}
</script>

<style scoped>

</style>
